<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    :before-close="handleCancel"
    width="30%">
    <el-descriptions :column="1" border size="mini" :labelStyle="{width: '100px'}">
      <el-descriptions-item label="姓名">
        <el-input :disabled="init_status!= -4" size="mini" v-model="fromData.realname"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="手机号">
        <el-input :disabled="init_status!= -4" size="mini" v-model="fromData.mobile"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="身份证号">
        <el-input :disabled="init_status!= -4" size="mini" v-model="fromData.idcard"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="银行名称">
        <el-input :disabled="init_status!= -4" size="mini" v-model="fromData.bank_name"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="银行账号">
        <el-input :disabled="init_status!= -4" size="mini" v-model="fromData.bank_account"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="状态">
        <span v-if="init_status>0">{{statusObj[init_status]}}</span>
        <el-select v-if="init_status<0" size="mini" v-model="fromData.status" placeholder="请选择">
          <el-option v-for="item in statusList" :label="item.name" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="备注">
        <el-input :disabled="init_status>0" size="mini" v-model="fromData.remark"></el-input>
      </el-descriptions-item>
    </el-descriptions>
    <span class="footer">
      <el-button type="info" @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit">调整</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ButlerHttp from "../common/ButlerHttp";

export default {
  name: "WithdrawForm",
  data() {
    return {
      visible: false,
      init_status: 4,
      statusList: [
        {name: "申请中", value: 1},
        {name: "收付易转账中", value: 2},
        {name: "薪酬易转账中", value: 3},
        {name: "成功", value: 4},
        {name: "收付易转账失败", value: -2},
        {name: "薪酬易转账失败", value: -3},
        {name: "提现失败", value: -4}
      ],
      statusObj:{
        "1":"申请中",
        "2":"收付易转账中",
        "3":"薪酬易转账中",
        "4":"成功",
        "-2":"收付易转账失败",
        "-3":"薪酬易转账失败",
        "-4":"提现失败",
      },
      fromData: {
        realname: "",
        mobile: "",
        idcard: "",
        bank_name: "",
        bank_account: "",
        status: "",
        remark: ""
      },
      callback: null
    };
  },
  methods: {
    show(fromData,callback){
      this.fromData = fromData;
      this.init_status = fromData.status;
      this.visible = true;
      this.callback = callback;
    },
    handleSubmit() {
      const that = this;
      let url="https://djshop.51homemoney.com/index.php/api/withdraw2/set_withdraw?token_key=4d510e0cf43132fe923c2fadebdca552";
      ButlerHttp.post(url, {
        ...that.fromData
      },ret=>{
        if(ret.code){
          that.callback(that.fromData);
          that.visible = false;
        }else {
          that.$message.error(ret.msg||"操作异常");
        }
      })
    },
    handleCancel() {
      this.visible = false;
      this.callback=null;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.footer{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/WithdrawForm.vue